<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Controle Análise</mat-label>
                <input matInput id="txtControleAnalise" #txtControleAnalise maxlength="10"
                  formControlName="controle_analise" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintControle}}</mat-hint>
                <mat-hint align="end">{{txtControleAnalise.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.controle_analise)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">CA limpeza</mat-label>
                <input matInput id="txtCaLimpeza" #txtCaLimpeza maxlength="10" formControlName="ca_limpeza" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCaLimpeza.value.length}} / 10</mat-hint>
                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_redigo)}}
                                </mat-error>-->
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                <mat-select #txtSite formControlName="site" disableCenteringOption disabled class="InputBlockColor">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSite($event.target.value)">
                  <mat-option *ngFor="let item of listSite" [value]="item.initials">
                    {{item.initials | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.site)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="row pt-3">
      
           <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Tratamento</mat-label>
                                <input matInput id="txtDataTratamento" #txtDataTratamento maxlength="10" mask="d0/M0/0000" 
                                    formControlName="data_tratamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDataTratamento.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_tratamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Produto
                                </mat-label>
                                <mat-select #txtTipoProduto formControlName="tipo_produto" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTipoProduto($event.target.value)">
                                    <mat-option *ngFor="let item of listTipoProduto" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div> 
          </div> -->
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Safra</mat-label>
                <mat-select #txtSafra formControlName="safra" disableOptionCentering>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSafra($event.target.value)">
                  <mat-option *ngFor="let item of listSafra" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Híbrido
                </mat-label>
                <mat-select #txtHibrido formControlName="hibrido" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterHibrido($event.target.value)">
                  <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peneira
                </mat-label>
                <mat-select #txtPeneira formControlName="peneira" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneira($event.target.value)">
                  <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Origem (lote ou tulha)</mat-label>
                <input matInput id="txtOrigem" #txtOrigem maxlength="10" formControlName="origem">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtOrigem.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.origem)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                <input matInput id="txtUmid" #txtUmid maxlength="10" formControlName="umidade" currencyMask>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtUmid.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.umidade)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Tipo Tratamento
                </mat-label>
                <mat-select #txtPeneira formControlName="tipo_tratamento" disableCenteringOption
                  (selectionChange)="changeTipoTratamento($event)">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterTipoTratamento($event.target.value)">
                  <mat-option *ngFor="let item of listTipoTratamento" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de 10.000 Sementes (g)</mat-label>
                <input matInput id="txtPesoDezMilSem" #txtPesoDezMilSem maxlength="7"
                  formControlName="peso_dez_mil_sementes" currencyMask (blur)="alertaPesoLiquidoRegulagemCBT200()"
                  (blur)="makeCalculationsII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoDezMilSem.value.length}} / 7</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_dez_mil_sementes)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número Sementes do Contador</mat-label>
                <input matInput id="txtNumSemCont" #txtNumSemCont maxlength="10" formControlName="num_sementes_contador"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtNumSemCont.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.num_sementes_contador)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número Sementes / kg</mat-label>
                <input matInput id="txtNumSemKg" #txtNumSemKg maxlength="10" formControlName="num_sementes" currencyMask
                  readonly class="InputBlockColor" (change)="makeCalculationsII()">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtNumSemKg.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.num_sementes)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de Mil Sementes (kg)</mat-label>
                <input matInput id="txtPesoMilSem" #txtPesoMilSem maxlength="10" formControlName="peso_mil_sementes"
                  currencyMask readonly class="InputBlockColor" (change)="makeCalculationsII()"
                  [options]="{ thousands: '.', decimal: ',', precision: 3 }">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoMilSem.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_mil_sementes)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Líquido para Regulagem CBT 200 (Kg)</mat-label>
                <input matInput id="txtPesoLiquRegCbt" #txtPesoLiquRegCbt maxlength="10"
                  formControlName="peso_liquido_regulagem_cbt" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoLiquRegCbt.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_liquido_regulagem_cbt)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md" *ngIf="isShowLotePosLimpeza">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote pós limpeza de linha? (Máx 800 scs)</mat-label>
                <mat-select #txtLtTratLimpLin formControlName="lote_pos_limpeza_de_linha" disableCenteringOption
                  (selectionChange)="onSelectLotePos()">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por...">
                  <mat-option *ngFor="let item of listOptionsLotePosLimpLin" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Turno</mat-label>
                <mat-select #txtTurno formControlName="turno" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterTurno($event.target.value)">
                  <mat-option *ngFor="let item of listTurno" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.turno)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>


        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>